'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

const wohnjoyFilterDraft = {
  panel(control) {
    return control.closest('#CollectionSidebar[data-wj-filter-apply]');
  },
  select(control, selected) {
    control.setAttribute('aria-pressed', String(selected));
    control.querySelector('.checkbox')?.classList.toggle('checked', selected);
    control.querySelector('.tooltip')?.classList.toggle('current-filter', selected);
    control.closest('li')?.classList.toggle('current-filter', selected);
  },
  toggle(control) {
    if (control.closest('.disabled') || control.classList.contains('option-disabled')) return;
    this.select(control, control.getAttribute('aria-pressed') !== 'true');
    this.counts(this.panel(control));
  },
  number(input) {
    let value = input.value.trim().replace(/\s/g, '');
    if (!value) return null;
    if (value.includes(',')) value = value.replace(/\./g, '').replace(',', '.');
    else if (input.dataset.wjPriceDecimal === ',' && /^\d{1,3}(\.\d{3})+$/.test(value)) value = value.replace(/\./g, '');
    const number = Number(value);
    return Number.isFinite(number) ? Math.max(0, number) : null;
  },
  price(panel) {
    const min = panel.querySelector('.min-price-range');
    const max = panel.querySelector('.max-price-range');
    const low = panel.querySelector('.range-slider-min');
    const high = panel.querySelector('.range-slider-max');
    if (!min || !max || !low || !high) return null;
    const limit = Number(high.max);
    const from = Math.min(this.number(min) ?? 0, limit);
    const to = Math.min(Math.max(this.number(max) ?? limit, from), limit);
    return { min, max, low, high, limit, from, to };
  },
  syncPrice(panel, source) {
    let price = this.price(panel);
    if (!price) return;
    const entry = (input, value) => value.toFixed(2).replace('.', input.dataset.wjPriceDecimal || '.');
    if (source === price.low) price.min.value = entry(price.min, Number(source.value));
    if (source === price.high) price.max.value = entry(price.max, Number(source.value));
    price = this.price(panel);
    if (source && price.min.value.trim()) price.min.value = entry(price.min, price.from);
    if (source && price.max.value.trim()) price.max.value = entry(price.max, price.to);
    price.low.value = String(price.from);
    price.high.value = String(price.to);
    const track = panel.querySelector('.drop-range');
    track?.style.setProperty('--range-from', (price.limit ? price.from * 100 / price.limit : 0) + '%');
    track?.style.setProperty('--range-to', (price.limit ? price.to * 100 / price.limit : 100) + '%');
    const form = price.min.closest('form');
    const money = value => typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function'
      ? Shopify.formatMoney(Math.round(value * 100), cartStrings.money_format)
      : new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: form.dataset.wjPriceCurrency || 'EUR' }).format(value);
    const minLabel = form.querySelector('.price-lable .min');
    const maxLabel = form.querySelector('.price-lable .max');
    if (minLabel) minLabel.innerHTML = money(price.from);
    if (maxLabel) maxLabel.innerHTML = money(price.to);
    this.counts(panel);
  },
  initPrice(panel) {
    const price = this.price(panel);
    if (!price) return;
    const form = price.min.closest('form');
    if (form.dataset.wjDraftPriceReady) return;
    form.dataset.wjDraftPriceReady = 'true';
    form.addEventListener('submit', event => event.preventDefault());
    [price.min, price.max].forEach(input => input.addEventListener('change', () => this.syncPrice(panel, input)));
    [price.low, price.high].forEach(input => input.addEventListener('input', () => this.syncPrice(panel, input)));
    this.syncPrice(panel);
  },
  counts(panel) {
    panel.querySelectorAll('[data-wj-filter-group]').forEach(group => {
      const badge = group.querySelector('[data-wj-filter-count]');
      if (!badge) return;
      let count = [...group.querySelectorAll('[data-wj-filter-param]')].filter(control => control.getAttribute('aria-pressed') === 'true').length;
      if (group.querySelector('.min-price-range')) {
        const price = this.price(panel);
        count = price && (price.from > 0 || price.to < price.limit) ? 1 : 0;
      }
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  },
  restore(panel) {
    panel.querySelectorAll('[data-wj-filter-param]').forEach(control => this.select(control, control.dataset.wjFilterApplied === 'true'));
    panel.querySelectorAll('.min-price-range,.max-price-range,.range-slider').forEach(input => { input.value = input.defaultValue; });
    this.syncPrice(panel);
    this.counts(panel);
  },
  clear(panel) {
    panel.querySelectorAll('[data-wj-filter-param]').forEach(control => this.select(control, false));
    panel.querySelectorAll('.min-price-range,.max-price-range').forEach(input => { input.value = ''; });
    this.syncPrice(panel);
    this.counts(panel);
  },
  url(panel) {
    const url = new URL(window.location.href);
    [...new Set(url.searchParams.keys())].forEach(key => {
      if (key.startsWith('filter.') || key === 'page' || key === 'section_id') url.searchParams.delete(key);
    });
    const selected = new Set();
    panel.querySelectorAll('[data-wj-filter-param]').forEach(control => {
      if (control.getAttribute('aria-pressed') !== 'true') return;
      const name = control.dataset.wjFilterParam;
      const value = control.dataset.wjFilterValue;
      const key = JSON.stringify([name, value]);
      if (!name || selected.has(key)) return;
      selected.add(key);
      url.searchParams.append(name, value);
    });
    const price = this.price(panel);
    if (price?.from > 0) url.searchParams.set(price.min.name, String(price.from));
    if (price && price.to < price.limit) url.searchParams.set(price.max.name, String(price.to));
    return url;
  },
  apply(panel) {
    const url = this.url(panel).href;
    panel.querySelector('close-filter')?.click();
    window.location.assign(url);
  },
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onOpen.bind(this), false);
  }
  onOpen() {
    if (this.collectionSidebar.hasAttribute('data-wj-filter-apply')) wohnjoyFilterDraft.restore(this.collectionSidebar);
    if (!this.classList.contains('open')) {
      this.collectionSidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
    } else {
      this.collectionSidebar.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      root.style.removeProperty('padding-right');
      this.classList.remove('open');
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    if (this.collectionSidebar.hasAttribute('data-wj-filter-apply')) wohnjoyFilterDraft.restore(this.collectionSidebar);
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelector('.btn-filter').classList.remove('open');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
  }
  onClose() {
    const panel = wohnjoyFilterDraft.panel(this);
    if (panel) wohnjoyFilterDraft.apply(panel);
    else super.onClose();
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    if (wohnjoyFilterDraft.panel(this)) {
      wohnjoyFilterDraft.toggle(this);
      return;
    }
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const panel = wohnjoyFilterDraft.panel(this);
    if (panel) {
      wohnjoyFilterDraft.clear(panel);
      return;
    }
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
  onClose() {
    if (!wohnjoyFilterDraft.panel(this)) super.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      const draftPanel = wohnjoyFilterDraft.panel(price_range);
      if (draftPanel) {
        wohnjoyFilterDraft.initPrice(draftPanel);
        return;
      }
      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute('name');
              const nameMax = maxPrice.getAttribute('name');
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace('?', '') + '&' + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (window.innerWidth <= 1024) {
            const collectionFilterBlocks = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.collectionFilterBlocks);
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.productgridcontainer);
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains('open')
            ) {
              document.querySelector(options_collection.collectionSidebar).classList.remove('open')
            }
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
          }
          document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
          const sectionElement = document.querySelector(
            '#productgridcontainer'
          );
          
          if (sectionElement) {
            const elementPosition = sectionElement.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset;
            const extraOffset = 100;
            const scrollToPosition =
              elementPosition + offsetPosition - extraOffset;
            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth',
            });
          }
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          const motionCollection = document.querySelector(".motion-collection");
          if (motionCollection) {
            motionCollection.reloadAnimationEffect();
          }
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
        });
      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, '', urlUpdate);
      } else {
        window.history.pushState({ url: url }, '', url);
      }
    },
  };
})();
eventCollectionShopify.init();
